module.exports = __webpack_public_path__ + "img/link-download-rb-hover.40454052.svg";